import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../../styles/profesional.css';
import './../../styles/profesional/home.css';
import * as globals from './../../components/GlobalScripts.js';
import Rating from './../rating/Rating';
import NavbarTop from './../default/Navbartop';

const Profesional_home_public = () => {
    let path_api = localStorage.getItem('path_api');
    const { id } = useParams();
    const [user, setUser] = useState([]);
    const [profesional, setProfesional] = useState([]);
    const [formDataSearchAct, setFormDataSearchAct] = useState({});

    useEffect(() => {
        const cachedData = localStorage.getItem('formDataSearch');
        if (cachedData) {
            setFormDataSearchAct(JSON.parse(cachedData));
        } 
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);
        }

        get_profil();
    }, []);

    const get_profil = () => {
        globals.openViewCharge();
        axios.post(`${path_api}/default/get_profile_public.php`, {
            rute: globals.getRuteBackend(),
            keylogin: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setProfesional(response.data.profile);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvo el perfil",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar el perfil",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const relevantReviews = profesional?.reviews?.filter(
        review => review.recieved === profesional?.keylogin && review.type === "cliente"
    ) || [];

    const averageRating =
        relevantReviews.length > 0
            ? relevantReviews.reduce((sum, review) => sum + Number(review.rating), 0) / relevantReviews.length
            : 0;

    return (
        <>
            <div className="app-profesional app-default app-container">
                <NavbarTop />
                <div className="main-content">
                    <div className="page-container">
                        <div className='container-profesional page-home container-section'>
                            <div className='left-side'>
                                <div className="profile-name">
                                    <img src={path_api + (profesional?.img_profile != '/images/profile_default.png'? profesional?.account?.img_profile: profesional?.img_profile)}></img>
                                    <div className='flex-column gap-5'>
                                        <h5>{typeof(profesional?.profile?.nombre_comercial) == 'string' && profesional?.profile?.nombre_comercial != '' ? profesional?.profile?.nombre_comercial : profesional?.account?.nombre + ' ' + profesional?.account?.apellidos}</h5>
                                        {!!averageRating && (
                                            <Rating rating={averageRating} size={20} />
                                        )}
                                        {!averageRating && (
                                            <div className="flex-column">
                                                <Rating rating={0} size={20} />
                                                <p>Sin evaluaciones</p>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <h5>Profesiones</h5>
                                    <div className='space-between'>
                                        <p><b>Principal:</b></p>
                                        <p>{profesional?.profile?.profesion}</p>
                                    </div>
                                    <div className="flex-column">
                                        <p><b>Secundarias:</b></p>
                                        <p>
                                            {Array.isArray(profesional?.profile?.profesiones) 
                                            ? profesional.profile.profesiones.join(', ') 
                                            : profesional?.profile?.profesiones || '—'}
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    <h5>Proyectos terminados</h5>
                                    <div className='space-between'>
                                        <p><b>Historico:</b></p>
                                        <p>{profesional?.proposal?.length ? profesional?.proposal?.length : 0}</p>
                                    </div>
                                    <div className='space-between'>
                                        <p><b>Ultimos 7 dias:</b></p>
                                        <p>
                                            {profesional?.proposal
                                                ? profesional.proposal.filter((project) => {
                                                    const projectDate = new Date(project.createAt);
                                                    const sevenDaysAgo = new Date();
                                                    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
                                                    return projectDate >= sevenDaysAgo;
                                                }).length
                                                : 0}
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    <h5>Cotización</h5>
                                    <div className='space-between'>
                                        <p><b>Categoria:</b></p>
                                        <p>{formDataSearchAct?.categoria}</p>
                                    </div>
                                    <div className='flex-column gap-10'>
                                        <p><b>Servicio requerido:</b></p>
                                        <p>{formDataSearchAct?.descripcion_servicio}</p>
                                    </div>
                                    {globals.isAuthenticated() && (
                                        <Link className='button-primary' to={`/chat/${profesional.keylogin}/?action=presupuesto`}>Pedir presupuesto</Link>
                                    )}
                                    {!globals.isAuthenticated() && (
                                        <Link to="/quiero-contratar" className='button-primary'>Solicitar Cotización</Link>
                                    )}
                                </div>
                            </div>
                            <div className="right-side">
                                <div className='flex-column gap-10'>
                                    <h4>Portafolio</h4>
                                    <div className="portafolio-list">
                                        {profesional.portfolio && profesional.portfolio.length > 0 ? (
                                            profesional.portfolio.map((portfolio, index) => (
                                                <div key={index} className="portafolio-item">
                                                    <h3>{portfolio?.titulo}</h3>
                                                    <p>{portfolio?.descripcion}</p>
                                                    {portfolio.imagenes && portfolio.imagenes.length > 0 && (
                                                        <div className="portfolio-images">
                                                            {portfolio.imagenes.map((img, i) => (
                                                                <div className="image" key={i}>
                                                                    <Link to={path_api + img.ruta} target='_blank'>
                                                                        <img src={path_api + img.ruta} alt={`Imagen ${i + 1}`} />
                                                                    </Link>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <h5>No tiene proyectos para mostrar.</h5>
                                        )}
                                    </div>
                                </div>

                                <div className='flex-column gap-10'>
                                    <h4>Proyectos finalizados</h4>
                                    <div className="projects">
                                        {profesional?.proposal?.length > 0 ? (
                                            profesional.proposal.map((project, index) => (
                                                <div key={index} className="project-item">
                                                    <h4>Título</h4>
                                                    <h5>{project.titulo}</h5>
                                                    <h4 className='margin-top-15'>Descripción</h4>
                                                    <p>{project.descripcion}</p>
                                                </div>
                                            ))
                                        ) : (
                                            <h5>De momento no tienes proyectos finalizados.</h5>
                                        )}
                                    </div>
                                </div>

                                <div className='flex-column gap-10'>
                                    {(() => {
                                        const professionalReviews =
                                            profesional?.reviews?.filter(
                                                review =>
                                                    review.recieved === profesional?.keylogin && review.type === "cliente"
                                            ) || [];
                                        return (
                                            <>
                                                <h4>Calificaciones de clientes ({professionalReviews.length})</h4>
                                                <div className="reviews">
                                                    {professionalReviews.length > 0 ? (
                                                        professionalReviews.map((review, index) => (
                                                            <div key={index} className="review-item">
                                                                <div className="flex-row gap-20">
                                                                    <img src={path_api + review.review_img_profile}></img>
                                                                    <div className='flex-column gap-10'>
                                                                        <h5>{review.review_nombre}</h5>
                                                                        <Rating rating={review.rating} size={20} />
                                                                        <p>{review.description}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <h5>No tienes reseñas para mostrar</h5>
                                                    )}
                                                </div>
                                            </>
                                        );
                                    })()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Profesional_home_public;